import { BaseFlowRuleStep } from "./BaseFlowRuleStep";
import { StatementRuleConfiguration } from "../../../Rule/Statement/StatementRuleConfiguration";

export class RunStatementRule extends BaseFlowRuleStep {
    readonly __type: string = "run_statement_rule";

    executable: StatementRuleConfiguration = new StatementRuleConfiguration();

    constructor() {
        super();
        this.name = "Run Statement Rule";
    }
}
